import { useEffect, useRef, useState } from 'react';
import { Button, Col, Divider, Form, Input, Popconfirm, Row, Select, Space, message } from 'antd';
import { DataIndexMenuEditModalContainer } from '../conversionMenu.style';
import { DataIndexItem } from '../../../types/interfaces';
import { LockOutlined, PlusOutlined, UnlockOutlined } from '@ant-design/icons';
import { unlockBatchItem, unlockDataItem, updateDataItemLambda } from '../../tables/dataIndexTable/DataIndexLambdaUtils';
import SourceInfoDetails from './conversionMenuData/SourceInfoDetails';
import { emitCustomEvent } from 'react-custom-events';
import { getDataItemFromDataId, updateItemStore } from '../../../store/DataStore';


const tagsData: string[] = [];




interface ProjectDetailsProps {
    onCancel: () => void;
    data: DataIndexItem
    onChanged: (dataId: string) => void;
}

const ProjectDetails = ({ onCancel, data, onChanged }: ProjectDetailsProps) => {
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [inputVisible, setInputVisible] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>('');
    const [selectedPermission, setSelectedPermission] = useState<string | null>(null);

    const permissionDetails = ["Permission1", "Permission2", "Permission3"];

    const [permissionData, setPermissionData] = useState<string[]>(permissionDetails);
    const [name, setName] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

      
    const onNameChange = (event:any) => {
        setName(event.target.value);
    };

    const addItem = () => {
        if (name && !permissionDetails.includes(name)) {
          setPermissionData([...permissionData, name]);
          permissionDetails.push(name);
          handlePermissionChange(name); // Assuming this function handles adding new permissions
          setName('');
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }
    };

    useEffect(() => {
        if(data.permission_group && !permissionData.includes(data.permission_group)) {
            setPermissionData([...permissionData, data.permission_group]);
        }
        if(data.tags?.length) {
            setSelectedTags(data.tags);
        }
    },[])


    const handleInputChange = () => {
        setInputVisible(true);
    };

    const handleTagSelect = (value: string) => {
        setSelectedTags([...selectedTags, value]);
        setInputVisible(false);
        setInputValue('');
    };

    const handleTagRemove = (tag: string) => {
        setSelectedTags(selectedTags.filter(t => t !== tag));
    };


    const handlePermissionChange = (value: string) => {
        setSelectedPermission(value);
    };

    const handleUnlock = () => {
        const dataType = data.batch ? "batch" : "data";
        setLoading(true);
        if (dataType === "batch") {
            // Unlock batch
            unlockBatchItem(data.data_id, data.owner_id).then(() => {
                setLoading(false);
                message.success("Batch unlocked successfully");
                data.locked = false;
                const dataP = getDataItemFromDataId(data.data_id);
                if (dataP) {
                    dataP.locked = false;
                }
                emitCustomEvent('unlocked', { data_id: data.data_id, owner_id: data.owner_id})
            }).catch((error) => {
                setLoading(false);
                message.error("Failed to unlock batch");
            });
        } else {
            unlockDataItem(data.data_id, data.owner_id).then(() => {
                setLoading(false);
                data.locked = false;
                const dataP = getDataItemFromDataId(data.data_id);
                if (dataP) {
                    dataP.locked = false;
                }
                emitCustomEvent('unlocked', { data_id: data.data_id, owner_id: data.owner_id })
                message.success("Data unlocked successfully");
            }).catch((error) => {
                setLoading(false);
                message.error("Failed to unlock data");
            });
            // Unlock data
        }
    };

    const handleProjectSave = (values : any) => {
        setLoading(true);
        let { name, permission_group } = values;

        if(!name) {
            name = data.name;
        }
        if(!permission_group) {
            permission_group = data.permission_group;
        }

        const tags = selectedTags;
        const params : any = {
            name,
            tags
        }

        if(!data.locked) {
            params['permission_group'] = permission_group;
        }

        updateDataItemLambda(data.data_id, data.owner_id, params).then((res) => {
            setLoading(false);
            updateItemStore(data.data_id, params)
            onChanged(data.data_id)
            message.success("Project updated successfully");
        }).catch((error) => {
            setLoading(false);
            message.error("Failed to update project");
        })

        // updateDataItemLambda
    }


    return (
        <DataIndexMenuEditModalContainer>
            <Form onFinish={handleProjectSave}>
                <div className="conversation__container">
                    <div className='form_block'>
                    <Row gutter={[20, 20]}>
                        <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                        <Row gutter={[20, 20]} className='project_input_row'>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}> {/* Adjust the span for each screen size */}
                                <label>Name</label>
                            </Col>
                            <Col xs={24} sm={24} md={16} lg={16} xl={16} className='project_input_column'>
                                <Form.Item
                                    name="name"
                                    className='form_input_item'
                                    initialValue={data?.name}
                                >
                                    <Input placeholder="Name" className="conversionName" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='project_input_row'>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <label>Tags Input</label>
                            </Col>
                            <Col xs={24} sm={24} md={16} lg={16} xl={16} className='tag_column project_input_column'>
                                <Form.Item
                                    name="tags"
                                    className='form_input_item'
                                    initialValue={inputValue}
                                >
                                    <Input
                                        placeholder="Select tags"
                                        value={inputValue}
                                        onClick={handleInputChange}
                                        onChange={(e) => setInputValue(e.target.value)}
                                        style={{ display: inputVisible ? 'block' : 'none' }}
                                    />
                                    <Select
                                        mode="tags"
                                        placeholder="Select tags"
                                        onSelect={handleTagSelect}
                                        onDeselect={handleTagRemove}
                                        popupClassName="custom_tag_dropdown"
                                        dropdownStyle={{
                                            backgroundColor: '#232529',
                                            color: '#ffffff !important'
                                        }}
                                        value={selectedTags}
                                        style={{ width: '100%', display: inputVisible ? 'none' : 'block' }}
                                    >
                                        {tagsData.map(tag => (
                                            <Select.Option key={tag} value={tag}>
                                                {tag}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='project_input_row'>
                            <Col xs={6} sm={6} md={8} lg={8} xl={8}>
                                <label>Lock Status</label>
                            </Col>
                            <Col xs={18} sm={18} md={16} lg={16} xl={16}>
                                <div className='col_inner_box'>
                                    <p>{data.locked ? "Locked" : "UnLocked"}</p>
                                    {data.locked ?
                                        <Popconfirm
                                            placement="topRight"
                                            title="If you unlock item, all builds will be lost. Are you sure you want to unlock?"
                                            onConfirm={() => handleUnlock()}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <LockOutlined className='lock_icon' />
                                        </Popconfirm>
                                        :<Popconfirm
                                            placement="topRight"
                                            title="This item is already unlocked, If you unlock item, all builds will be lost. Are you sure you want to unlock it again?"
                                            onConfirm={() => handleUnlock()}
                                            okText="Yes"
                                            cancelText="No"
                                        > 
                                            <UnlockOutlined disabled={true} className='lock_icon' />
                                        </Popconfirm>}
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='project_input_row'>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <label>Permission Group</label>
                            </Col>
                            <Col xs={24} sm={24} md={16} lg={16} xl={16} className='project_input_column'>
                                <Form.Item
                                    name="permission_group"
                                    className='form_input_item'
                                >
                                    <Select
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Search.."
                                        optionFilterProp="children"
                                        onChange={handlePermissionChange}
                                        value={selectedPermission}
                                        className='permission_select'
                                        defaultValue={data.permission_group}
                                        disabled={data.locked}
                                        dropdownRender={(menu) => (
                                            <>
                                              {menu}
                                              <Divider style={{ margin: '8px 0' }} />
                                                    <Space style={{ padding: '0 8px 4px' }}>
                                                        <input
                                                        placeholder="Enter custom permission"
                                                        ref={inputRef}
                                                        value={name}
                                                        onChange={onNameChange}
                                                        onKeyDown={(e) => e.stopPropagation()}
                                                        className='permission_input'
                                                        />
                                                        <Button type="text" icon={<PlusOutlined />} className="permission_custom_btn"  onClick={addItem}>
                                                        Add item
                                                        </Button>
                                                    </Space>
                                            </>
                                        )}
                                    >
                                        {permissionData.map((item, index) => (
                                            <Select.Option key={index} value={item}>
                                                {item}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        </Col>
                        <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                            {
                                !data.batch && <SourceInfoDetails data={data} />
                            }
                        </Col>
                    </Row>
                    </div>
                    <div className='footer_box'>
                        <div className='footer_inner_box'>
                            <Button htmlType='submit' className='footer_btn footer_btn_save' loading={loading}>Save</Button>
                            <Button className='footer_btn footer_btn_cancel' onClick={() => onCancel()}>Cancel</Button>
                        </div>
                    </div>
                </div>
            </Form>
        </DataIndexMenuEditModalContainer>
    );
}

export default ProjectDetails;
